export default __webpack_public_path__ + "static/modal-16f5baed11d89e9ba18693de84eef69e.jpg";